export default {
	"6ae2087a39450e7c22da0d16d7649fd1": "Hint",
	"879fec06ccfe97dc0ccd40d6753d4ea9": "Unbound for the time being",
	"0d50282e0f3530aa98804b69b3862964": "Unbind the account",
	"ec21d9ecb931b185b3828e4c2529c92a": "According to the requirements of national policies, for express items sent to Taiwan region, the ID number needs to be filled in. Please fill it in",
	"90ed3dbbea5261a517d1c1eefba4a3f8": "Cancel",
	"6858786ff5eae6ee8331ded3dd5b88ee": "Go and supplement",
	"f956b08ed77c62d8a236002533993633": "Sorry, the price has changed!",
	"6d20ed71e31f315ebff227d96605fdda": "Sorry, the order creation failed!",
	"0acd53438c56e1f86a95786c4e76da12": "System error"
}
